// extracted by mini-css-extract-plugin
export default {"title":"quick-charge-method-modal_title__Di72F","options":"quick-charge-method-modal_options__BFITw","option":"quick-charge-method-modal_option__CPp2X"};